import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storageKey = 'lang';
  private currentLanguage = new BehaviorSubject<string>('en');
  private currentProduct = new BehaviorSubject<string>('individual');
  private isIgnored: boolean = false;

  language$ = this.currentLanguage.asObservable();
  product$ = this.currentProduct.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    if (isPlatformBrowser(this.platformId)) {
      const storedLang = localStorage.getItem(this.storageKey);

      if (storedLang) {
        this.currentLanguage.next(storedLang);
      }

      window.addEventListener('storage', (event) => {
        if (event.key === this.storageKey) {
          this.isIgnored = true;

          if (event.newValue !== this.currentLanguage.value) {
            console.log('Language changed in other window of browser.');
          }
        }
      });
    }
  }

  setItem(key: string, value: string) {
    if (isPlatformBrowser(this.platformId) && !this.isIgnored) {
      localStorage.setItem(key, value);
      this.currentLanguage.next(value);
    }
  }

  getItem(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(key);
    }

    return null;
  }

  removeItem(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
    }
  }
}
